import React, { Component } from 'react';
import { connect } from 'react-redux';

import Menu from 'controls/menu/Menu';
import Toolbar from 'components/track-templates/toolbar/Toolbar';
import List from 'components/track-templates/list/List';

class TrackTemplates extends Component {
  render () {
    return (
      <div>
        <Menu/>
        <Toolbar trackId={ this.props.trackId }/>
        <List trackId={ this.props.trackId }/>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    trackId: ownProps.match.params.trackId
  };
}

export default connect(mapStateToProps, () => { return{} })(TrackTemplates);
